import { formatSnakeCaseToRawCaps } from 'pages/EnergyEfficiency/EnergyEfficiencyRigPage/utils/converters';
import { RigsByWellDTO } from 'types/indicators';

import { PATHS } from './paths';

export enum ENERGY_EFFICIENCY_MODULES {
  ENERGY_EFFICIENCY_WELL = 'ENERGY_EFFICIENCY_WELL',
  ENERGY_EFFICIENCY_RIG = 'ENERGY_EFFICIENCY_RIG',
  ENERGY_EFFICIENCY_RIGS_LOADING = 'ENERGY_EFFICIENCY_RIGS_LOADING',
  ENERGY_EFFICIENCY_RIGS_ERROR = 'ENERGY_EFFICIENCY_RIGS_ERROR',
}

export const energyEfficiencyWellTab: {
  name: ENERGY_EFFICIENCY_MODULES;
  displayedName: string;
  path: string;
} = {
  name: ENERGY_EFFICIENCY_MODULES.ENERGY_EFFICIENCY_WELL,
  displayedName: `header.pages.${ENERGY_EFFICIENCY_MODULES.ENERGY_EFFICIENCY_WELL}`,
  path: PATHS.ENERGY_EFFICIENCY_WELL,
};

const energyEfficiencyBasicRigTab = {
  name: ENERGY_EFFICIENCY_MODULES.ENERGY_EFFICIENCY_RIG,
  displayedName: `header.pages.${ENERGY_EFFICIENCY_MODULES.ENERGY_EFFICIENCY_RIG}`,
  path: PATHS.ENERGY_EFFICIENCY_RIG,
};

const energyEfficiencyRigsLoadingTab = {
  name: ENERGY_EFFICIENCY_MODULES.ENERGY_EFFICIENCY_RIGS_LOADING,
  displayedName: `header.pages.${ENERGY_EFFICIENCY_MODULES.ENERGY_EFFICIENCY_RIGS_LOADING}`,
  path: PATHS.ENERGY_EFFICIENCY_WELL + `?loading=true`,
};

const energyEfficiencyRigsErrorTab = {
  name: ENERGY_EFFICIENCY_MODULES.ENERGY_EFFICIENCY_RIGS_ERROR,
  displayedName: `header.pages.${ENERGY_EFFICIENCY_MODULES.ENERGY_EFFICIENCY_RIGS_ERROR}`,
  path: PATHS.ENERGY_EFFICIENCY_WELL + `?error=true`,
};

export const energyEfficiencyTabs = [
  energyEfficiencyWellTab,
  energyEfficiencyBasicRigTab,
  energyEfficiencyRigsLoadingTab,
  energyEfficiencyRigsErrorTab,
];

export const getEnergyEfficiencyRigTabs = (
  wellName: string | undefined,
  currentWellRigsFetchData: RigsByWellDTO | undefined,
  isCurrentWellRigsFetchLoading: boolean,
  isCurrentWellRigsFetchError: boolean,
) => {
  if (isCurrentWellRigsFetchLoading) {
    return [energyEfficiencyRigsLoadingTab];
  }
  if (isCurrentWellRigsFetchError || currentWellRigsFetchData === undefined) {
    return [energyEfficiencyRigsErrorTab];
  }

  return currentWellRigsFetchData.rigIds.map(rigId => {
    return {
      name: ENERGY_EFFICIENCY_MODULES.ENERGY_EFFICIENCY_RIG,
      displayedName: formatSnakeCaseToRawCaps(rigId),
      path: PATHS.ENERGY_EFFICIENCY_RIG + `?rigId=${rigId}&wellName=${wellName}`,
    };
  });
};

export const energyEfficiencyModules = Object.values(ENERGY_EFFICIENCY_MODULES);
